export const CONTAINER_SIZES = [
    '1x20',
    '2x20',
    '1x40',
    'LB 1x20',
    'LB 1x40',
    'H. EQUIP',
    'H. EQUIP 2x'
]


// WEBPACK FOOTER //
// ./src/app/contants/CONTAINER_SIZES.ts